<div class="storage-banner" *ngIf="!isLoading && isFreePlan">

  <!-- Storage gauge icon -->
  <div class="storage-icon-wrap" [attr.aria-label]="usagePercent + '% storage used'">
    <svg class="gauge-ring" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
      <circle class="gauge-track" cx="22" cy="22" r="18" />
      <circle
        class="gauge-fill"
        cx="22"
        cy="22"
        r="18"
        [style.stroke-dasharray]="(usagePercent / 100 * 113.1) + ' 113.1'"
      />
    </svg>
    <svg  class="chip-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C5.28595 20 2.92893 20 1.46447 18.5355C0 17.0711 0 14.714 0 10C0 5.28595 0 2.92893 1.46447 1.46447C2.92893 0 5.28595 0 10 0C10.3415 0 10.5122 0 10.6858 0.0151549C11.4951 0.0858056 12.2874 0.413997 12.9097 0.936312C13.0431 1.04835 13.1668 1.17206 13.4142 1.41944L18.5806 6.58578C18.828 6.83317 18.9516 6.95687 19.0637 7.09034C19.586 7.71257 19.9142 8.50489 19.9848 9.31421C20 9.48781 20 9.65854 20 10C20 14.714 20 17.0711 18.5355 18.5355C17.0711 20 14.714 20 10 20ZM11 3.25C11.4142 3.25 11.75 3.58579 11.75 4V7C11.75 7.41421 11.4142 7.75 11 7.75C10.5858 7.75 10.25 7.41421 10.25 7V4C10.25 3.58579 10.5858 3.25 11 3.25ZM8.75 4C8.75 3.58579 8.41421 3.25 8 3.25C7.58579 3.25 7.25 3.58579 7.25 4V7C7.25 7.41421 7.58579 7.75 8 7.75C8.41421 7.75 8.75 7.41421 8.75 7V4ZM5 3.25C5.41421 3.25 5.75 3.58579 5.75 4V7C5.75 7.41421 5.41421 7.75 5 7.75C4.58579 7.75 4.25 7.41421 4.25 7V4C4.25 3.58579 4.58579 3.25 5 3.25Z" fill="currentColor"/>
</svg>

    <!-- <svg class="chip-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
      <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" stroke-width="1.6"/>
      <rect x="7" y="7" width="10" height="10" rx="1" stroke="currentColor" stroke-width="1.4"/>
      <line x1="8"  y1="2" x2="8"  y2="4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <line x1="12" y1="2" x2="12" y2="4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <line x1="16" y1="2" x2="16" y2="4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <line x1="8"  y1="20" x2="8"  y2="22" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <line x1="12" y1="20" x2="12" y2="22" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <line x1="16" y1="20" x2="16" y2="22" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <line x1="2"  y1="8"  x2="4"  y2="8"  stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <line x1="2"  y1="12" x2="4"  y2="12" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <line x1="2"  y1="16" x2="4"  y2="16" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <line x1="20" y1="8"  x2="22" y2="8"  stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <line x1="20" y1="12" x2="22" y2="12" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <line x1="20" y1="16" x2="22" y2="16" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </svg> -->
  </div>

  <!-- Info text: label + hint stacked in one column -->
  <div class="storage-info">
    <span class="storage-label">{{ usedGB }} GB / {{ totalGB }} GB used</span>
    <span class="storage-hint">{{ photosLeft | number }} photos or {{ videoMinsLeft }} mins of video left</span>
  </div>

  <!-- Upgrade CTA -->
  <button class="upgrade-btn" (click)="navigateToUpgrade()">
    Upgrade
    <svg class="arrow-icon" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <path d="M6.22 3.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06L7.28 12.78a.75.75 0 1 1-1.06-1.06L9.94 8 6.22 4.28a.75.75 0 0 1 0-1.06Z"/>
    </svg>
  </button>

</div>
